<div class="rating-container">
    <span *ngFor="let rating of ratings"
          (click)="setRating(rating)"
          (mouseover)="setHover(rating)"
          (mouseleave)="clearHover()"
          [class.filled]="rating <= (hoverRating || currentRating)"
          class="svg-circle"
          [class.error]="question.hasError"
          [attr.data-value]="rating">
        <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
            <circle cx="12" cy="12" r="10"></circle>
        </svg>
    </span>
</div>
